import theme from '../../theme/theme';

const {
  colors: { white_text, open_logo },
} = theme;

const styles = {
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    height: '8vh',
    paddingLeft: '8%',
    paddingRight: '8%',
  },

  logo__container: {
    flexBasis: '25%',
  },

  open__logo: {
    fontSize: '1.1em',
    outline: '2px',
    color: white_text,
    backgroundColor: open_logo,
    padding: '0 0.9em 0.3em 0.8em',
    borderRadius: '0.9em',
  },

  title: {
    display: 'flex',
    flexBasis: '50%',
    margin: 'auto 0',
  },

  arrrow: {
    flexBasis: '25%',
    margin: 'auto 0',
  },
};

export default styles;
